
define('text!templates/parts/tutorial-box.html',[],function () { return '<div class="check {{#isCompleted}}completed{{/isCompleted}}">\n\n    <div data-toggle="tooltip" data-placement="bottom" title="{{#t}}Mark as done{{/t}}" class="checkbox"></div>\n\n    <span class="task">{{#t}}{{ name }}{{/t}}</span>\n\n</div>\n';});

